import { createContext, useContext } from 'react';

export interface WhatsNewControls {
    isOpen: boolean;
    openWhatsNew: () => void;
    closeWhatsNew: () => void;
}

export const WhatsNewContext = createContext<WhatsNewControls | undefined>(undefined);

export function useWhatsNewControls(): WhatsNewControls {
    const context = useContext(WhatsNewContext);
    if (context === undefined) {
        throw new Error('useWhatsNewControls must be used within a WhatsNewProvider');
    }
    return context;
}
